import { RootState } from '../store/configureStore';

export const getProductTypes = (state: RootState) => state?.productType?.productTypes?.filter(c => c.product_type_code !== 'J' &&  c.product_type_code !== 'W');

export const isFetchingProductTypes = (state: RootState) =>
  state?.productType?.isFetchingProductTypes;

export const didFetchingProductTypesFailed = (state: RootState) =>
  state?.productType?.fetchingProductTypesFailed;
